/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Auth0Client, CacheLocation } from "@auth0/auth0-spa-js";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { SetGlobalStyle } from "@nordcloud/gnui";
// eslint-disable-next-line import/no-internal-modules
import "react-toastify/dist/ReactToastify.css";
import { Auth0ProviderWithHistory, AuthWall } from "~/components/Auth/auth";
import Login from "~/components/Auth/Login";
import {
  AUTH0_CACHE_LOCATION,
  AUTH0_CLIENT_ID,
  AUTH0_DOMAIN,
  BASE_NAME,
} from "~/components/config";
import "./assets/styles/global.css";

import App from "./App";

if (BASE_NAME) {
  document.cookie = `base_name=${BASE_NAME}; Path=/; SameSite=lax; Secure`;
}

if (!navigator.userAgent.includes("jsdom")) {
  const auth0 = new Auth0Client({
    domain: AUTH0_DOMAIN,
    client_id: AUTH0_CLIENT_ID, // eslint-disable-line
    redirect_uri: window.location.origin, // eslint-disable-line
    cacheLocation: AUTH0_CACHE_LOCATION as CacheLocation,
  });

  ReactDOM.render(
    <BrowserRouter basename={BASE_NAME}>
      <Auth0ProviderWithHistory client={auth0}>
        <SetGlobalStyle />
        <Login>
          <AuthWall>
            <React.StrictMode>
              <App />
            </React.StrictMode>
          </AuthWall>
        </Login>
      </Auth0ProviderWithHistory>
    </BrowserRouter>,
    document.getElementById("root")
  );
}
